'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { notify } from '@/lib/notify';

const NETWORK_TOAST_ID = 'network-status';

export const NetworkStatusToasts = () => {
  const t = useTranslations('toasts');

  useEffect(() => {
    const onOffline = () => {
      notify.warning(t('offline'), { id: NETWORK_TOAST_ID, duration: Infinity });
    };
    const onOnline = () => {
      notify.success(t('online'), { id: NETWORK_TOAST_ID, duration: 3000 });
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, [t]);

  return null;
};
